// Library import
import axios from 'axios';

// File Import
import {apiEndPoints} from './apiEndPoints';

export class UserApi {
    // Create new user
    static createUser(payload) {
        return axios.post(apiEndPoints.USER.CREATE_USER, payload);
    }

    // Delete a user
    static deleteUser(userId) {
        return axios.delete(apiEndPoints.USER.DELETE_USER(userId));
    }

    // Update a user
    static updateUser(payload) {
        return axios.put(apiEndPoints.USER.UPDATE_USER(payload?.id), payload);
    }
}
